// constants.js
//http://192.168.21.138:8080/
import { differenceInDays as daydif } from "date-fns";

export const port = "8080";
export const route = "http://localhost:";
export const PAYS = "FRANCE";

const currencyMap = {
  "€": "EUR",
  "$": "USD",
  "£": "GBP",
  "¥": "JPY",
  // ajoute d'autres si nécessaire
};

export function formatMoney(amount, devise = "€") {
  if (amount == null) return "-";

  const currency = currencyMap[devise] || "EUR"; // fallback sur EUR

  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export const calculateNights = (startDate, endDate) => {
  // Regular expression to check if the date is in yyyy-mm-dd format
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;

  // Check if the dates match the pattern
  if (!datePattern.test(startDate) || !datePattern.test(endDate)) {
    return 1;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Calculate the difference in days using date-fns
  const differenceInDays = daydif(end, start);

  return differenceInDays;
};
export const formatDate = (date) => {
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

export const getMinMaxPrice = (logements) => {
  if (logements.length === 0) return { min: 0, max: 0 };

  let min = logements[0].prix;
  let max = logements[0].prix;

  logements.forEach((logement) => {
    if (logement.prix < min) min = logement.prix;
    if (logement.prix > max) max = logement.prix;
  });

  return { min, max };
};

// Function to save a value
export const saveValue = async (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error("Error saving to localStorage", error);
  }
};

// Function to retrieve a value
export const getValue = async (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error("Error retrieving from localStorage", error);
    return null;
  }
};

// Function to clear a session (remove a key)
export const clearSession = async (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing from localStorage", error);
  }
};

// Function to format an amount
export const formatAmount = (amount) => {
  try {
    const formatter = new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
    });
    return formatter.format(amount);
  } catch (error) {
    console.error("Error formatting amount", error);
    return amount;
  }
};
// Listes de référence pour chaque type d'équipement ou d'accessibilité
export const produitsServicesBaseEquipement = [
  { value: "Wifi", id: "1" },
  { value: "Cuisine", id: "2" },
  { value: "Lave-linge", id: "3" },
  { value: "Climatisation", id: "4" },
  { value: "Espace de travail dédié", id: "5" },
  { value: "Sèche-cheveux", id: "6" },
  { value: "Sèche-linge", id: "7" },
  { value: "Chauffage", id: "8" },
  { value: "Télévision", id: "9" },
  { value: "Fer à repasser", id: "10" },
];

export const caracteristiquesEquipement = [
  { value: "Piscine", id: "1" },
  { value: "Jacuzzi", id: "2" },
  { value: "Parking gratuit", id: "3" },
  { value: "Station de recharge pour véhicules électriques", id: "4" },
  { value: "Lit king size", id: "5" },
  { value: "Lit pour bébé", id: "6" },
  { value: "Salle de sport", id: "7" },
  { value: "Barbecue", id: "8" },
  { value: "Petit déjeuner", id: "9" },
  { value: "Cheminée", id: "10" },
  { value: "Logement fumeur", id: "11" },
];

export const emplacementEquipement = [
  { value: "Bord de mer", id: "1" },
  { value: "Font de mer", id: "2" },
  { value: "Accessible à skis", id: "3" },
];

export const securiteEquipement = [
  { value: "Détecteur de fumée", id: "1" },
  { value: "Détecteur de monoxyde de carbone", id: "2" },
];

export const entreStationVoyageursAccessibilite = [
  { value: "Entrée de plain-pied pour les voyageurs", id: "1" },
  {
    value: "Largeur de l'entrée des voyageurs supérieure à 81 centimètres",
    id: "2",
  },
  { value: "Accès de plain-pied à l'entrée", id: "3" },
  { value: "Place de parking accessible", id: "4" },
];

export const chambreAccessibilite = [
  { value: "Accès de plain-pied à la chambre", id: "1" },
  {
    value: "Largeur de l'entrée de la chambre supérieure à 81 centimètres",
    id: "2",
  },
];

export const salleBainAccessibilite = [
  { id: "1", value: "Accès de plain-pied à la salle de bains" },
  {
    id: "2",
    value:
      "Largeur de l'entrée de la salle de bain supérieure à 81 centimètres",
  },
  { id: "3", value: "Barre d'appui pour toilettes" },
  { id: "4", value: "Barre d'appui pour douche" },
  { id: "5", value: "Douche de plain-pied" },
  { id: "6", value: "Siège de douche ou de bain" },
];

// Function to extract values corresponding to IDs from logementData
export const getValuesFromIds = (logementData, inputString) => {
  const values = [];

  // Iterate over inputString keys
  for (const key in inputString) {
    if (inputString.hasOwnProperty(key)) {
      const ids = inputString[key].split("#").filter((id) => id !== "");

      // Use switch statement to select the appropriate list based on key
      let listToUse;
      switch (key) {
        case "produitsServicesBaseEquipement":
          listToUse = produitsServicesBaseEquipement;
          break;
        case "caracteristiquesEquipement":
          listToUse = caracteristiquesEquipement;
          break;
        case "emplacementEquipement":
          listToUse = emplacementEquipement;
          break;
        case "securiteEquipement":
          listToUse = securiteEquipement;
          break;
        case "entreStationVoyageursAccessibilite":
          listToUse = entreStationVoyageursAccessibilite;
          break;
        case "chambreAccessibilite":
          listToUse = chambreAccessibilite;
          break;
        case "salleBainAccessibilite":
          listToUse = salleBainAccessibilite;
          break;
        default:
          listToUse = [];
          break;
      }

      // If listToUse is defined, find corresponding values
      if (listToUse) {
        ids.forEach((id) => {
          const foundObject = listToUse.find((obj) => obj.id === id);
          if (foundObject) {
            values.push(foundObject.value);
          }
        });
      }
    }
  }

  return values;
};
